import {PluginRunner} from '../../../jsmod/js/registerPlugin';

export class CartInfo {
  public static updated(instance: CartInfo, oldEl, newEl) {
    PluginRunner.getInstance().replaceEl(oldEl, newEl);
  }

  public static frontend(el: HTMLElement, opt: any) {
    return new this();
  }
}
